import React, { useState, useEffect, useRef } from "react";
import "./Banner.css";
import { FaRegTimesCircle } from "react-icons/fa";

const Banner = () => {
  const [isVisible, setIsVisible] = useState(true);
  const bannerRef = useRef(null);

  // Expose the banner height so fixed bottom bars can sit above it. The
  // height changes with the screen width (text on more lines), so it is
  // measured again whenever the banner is resized.
  useEffect(() => {
    const root = document.documentElement;
    const element = bannerRef.current;
    const update = () => {
      const height = isVisible && element ? element.offsetHeight : 0;
      root.style.setProperty("--banner-offset", `${height}px`);
    };

    update();

    if (!isVisible || !element) return undefined;

    if (typeof ResizeObserver === "undefined") {
      window.addEventListener("resize", update);
      return () => window.removeEventListener("resize", update);
    }

    const observer = new ResizeObserver(update);
    observer.observe(element);

    return () => observer.disconnect();
  }, [isVisible]);

  // Charger l'état initial à partir du sessionStorage
  useEffect(() => {
    const bannerState = sessionStorage.getItem("bannerClosed");
    if (bannerState === "true") {
      setIsVisible(false);
    }
  }, []);

  const closeBanner = () => {
    setIsVisible(false);
    // Sauvegarder dans le sessionStorage que la bannière est fermée
    sessionStorage.setItem("bannerClosed", "true");
  };

  // Ne pas afficher la bannière si elle est fermée
  if (!isVisible) {
    return null;
  }

  return (
    <div className="banner" ref={bannerRef}>
      <button className="close-banner" onClick={closeBanner}>
        <FaRegTimesCircle color="#FFF" size={24} />
      </button>
      <p>
        ⚠️ Veuillez noter : Nous ne demanderons jamais vos coordonnées
        bancaires, PIN ou OTP via SMS, appel, email ou WhatsApp. <br />
        Ne répondez pas à ces demandes.
      </p>
    </div>
  );
};

export default Banner;
